export default __webpack_public_path__ + "static/media/experience-icon.9f692f4f.png";